import React from "react";
import {
  Typography,
  Container,
  Paper,
  Grid,
  Card,
  CardContent,
  Box,
  Button,
} from "@mui/material";
import {
  Business,
  Gavel,
  Wifi,
  SmartToy,
  Science,
  Launch as LaunchIcon,
  BrandingWatermark,
} from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import SetDocumentMeta from "../common/SetDocumentMeta";

const sections = [
  {
    title: "Patent Practice",
    icon: (tertColor) => <Gavel fontSize="large" sx={{ color: tertColor }} />,
    content: `We help clients secure, optimize, and monetize their intellectual property portfolios, particularly in high-tech electrical innovations. 
    Our expertise spans AI/ML, integrated circuits, antennas, embedded systems, wireless communications, medical devices, radio frequency circuits and systems, and more.`,
    link: "/patents",
  },
  {
    title: "AI Counseling",
    icon: (tertColor) => (
      <SmartToy fontSize="large" sx={{ color: tertColor }} />
    ),
    content: `We provide legal guidance for AI startups and enterprises, including drafting AI-related agreements. 
    We also evaluate AI tools and automation workflows for legal risks in complex technical applications, pre-process, label, and annotate AI training data for legal applications.`,
    link: "/ai",
  },
  {
    title: "Wireless Telecom Law",
    icon: (tertColor) => <Wifi fontSize="large" sx={{ color: tertColor }} />,
    content: `We assist clients with FCC compliance, spectrum licensing, equipment authorization, wireless infrastructure deployment, antenna siting, and emerging wireless technologies.`,
    link: "/wireless",
  },
  {
    title: "Technology Transactions & Licensing",
    icon: (tertColor) => (
      <Business fontSize="large" sx={{ color: tertColor }} />
    ),
    content: `Our firm provides expertise in patent licensing, IP valuation, technology transactions, and strategic counseling to help clients monetize their innovations effectively.`,
    link: "/software-licensing",
  },
  {
    title: "Regulatory & Policy Advocacy",
    icon: (tertColor) => <Science fontSize="large" sx={{ color: tertColor }} />,
    content: `We represent clients in regulatory matters before the FCC and other agencies, providing strategic advocacy and compliance support for wireless and AI technologies.`,
    link: "/wireless#regulatory-advocacy",
  },
  {
    title: "Technology Branding",
    icon: (tertColor) => (
      <BrandingWatermark fontSize="large" sx={{ color: tertColor }} />
    ),
    content: `We help clients protect and enforce trademarks and branding assets, particularly for AI and tech-driven products.`,
    link: "/trademarks",
  },
];

const AboutKth = ({ baseConfig }) => {
  const { tertColor, tertHoverColor } = baseConfig.siteBranding;

  SetDocumentMeta({
    title: "About Us | Kama Thuo, PLLC",
    description: "",
    keywords: "",
  });

  return (
    <Container className="link-no-decoration" sx={{ py: 5 }}>
      <Typography variant="h3" align="center" gutterBottom>
        About Kama Thuo, PLLC
      </Typography>
      <Typography variant="h6" align="center" color="textSecondary" paragraph>
        Kama Thuo, PLLC is a boutique law firm specializing in patent law, AI
        legal counseling, and wireless telecommunications law. Founded by Roque
        Thuo, an experienced Intellectual Property (IP) attorney and licensed
        Professional Engineer (Electrical), we bring a unique combination of
        BigLaw expertise and hands-on engineering experience.
      </Typography>

      <Grid container spacing={4} sx={{ mt: 4 }}>
        {sections.map((section, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                p: 2,
              }}
            >
              <Box sx={{ mt: 2 }}>{section.icon(tertColor)}</Box>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" gutterBottom>
                  {section.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  textAlign="left"
                >
                  {section.content}
                </Typography>
              </CardContent>

              {section.link && (
                <Box sx={{ mb: 2 }}>
                  <Button
                    startIcon={<LaunchIcon />}
                    variant="contained"
                    sx={{
                      backgroundColor: tertColor,
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: tertHoverColor,
                        color: "#fff",
                      },
                    }}
                    component={RouterLink}
                    to={section.link}
                  >
                    Learn More
                  </Button>
                </Box>
              )}
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default AboutKth;
